export default __webpack_public_path__ + "static/media/Landing.05a7f8d5.png";